import { createFileRoute } from '@tanstack/react-router';

import { ProjectBrowse } from '@/module/Author/Project';

export const Route = createFileRoute('/_auth/author/_author/project/_project/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProjectBrowse />;
}
